<svelte:options
  customElement={{
    tag: "cta-modal",
    shadow: "none"
  }}
/>
<script>
  import { onMount } from 'svelte';
  import { modalCtaAction } from '../modules/AppDownloadModalAction.js';
  const crossIcon = "/assets_default/icons/cross.svg"
  const Qrcode = "/assets_default/images/common/qr_code.webp"
  let { appIcon, CTA } = $props();

  onMount(() => {
    modalCtaAction();
  });
</script>

<div class="owd-cta-modal">
  <div class="owd-cta-modal-container">
    <img class="owd-cta-modal-close" src={crossIcon} alt="クロスアイコン">
    <div class="owd-cta-modal-inner">
      <div class="owd-cta-modal-inner-item">
        <div class="owd-cta-modal-inner-labelarea">
          <img src={appIcon} alt="アプリアイコン">
          <p class="owd-heading:03">まずはみんなの銀行<br>アプリをダウンロード</p>
        </div>
        <div class="owd-cta-modal-inner-item-qrarea">
          <p class="owd-text:02 align:left">時間を気にせず、<br>いつでも口座開設ができます。</p>
          <img class="owd-cta-modal-inner-qr" src={Qrcode} alt="QRコード">
        </div>
      </div>
      <div class="owd-cta-modal-inner-image">
        <img src={CTA} alt="アプリ画面">
      </div>
    </div>
  </div>
</div>
<style lang="scss">

  .owd-cta-modal{
    &-close{
      width: 24px;
      position: absolute;
      top: 24px;
      right: 30px;
      transform: translate(50%,-50%);
      cursor: pointer;
      @include g.mobile {
        top: clamp(5px,4%,24px);
        right: clamp(5px,2.5%,30px);
      }
    }
    &-container {
      width: 98%;
      max-width: 741px;
      padding: 48px;
      background-color: var(--primary-white);
      position: relative;
      @include g.mobile {
        padding: clamp(20px,4vw,48px);
      }
    }
    &-inner{
      padding: 40px;
      background-color: var(--light-gray);
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 16px;
      @media (max-width: 741px) {
        padding: clamp(12px,3vw,40px);
        gap: clamp(5px,2vw,16px);
      }
      &-labelarea{
        display: flex;
        align-items: center;
        gap: 16px;
        margin-bottom: 24px;
        p{
          letter-spacing: 0.025em;
          @media (max-width: 741px) {
            @include g.owd-typography($fz: 'heading-1', $line-height-px: 28, $letter-spacing-tracking: 50, $font-weight: 600);
          }
        }
        img{
          width: 76px;
          @media (max-width: 741px) {
            width: clamp(30px,10vw,76px);
          }
        }
      }
      &-item{
        &-qrarea{
          display: flex;
          align-items: center;
          gap: 12px;
          margin-top: 24px;
          border-top: solid 1px var(--primary-black);
          padding-top: 24px;
          @media (max-width: 741px) {
            gap: clamp(5px,1.8vw,12px);
          }
          img{
            width: 76px;
          }
        }
      }
      &-qr{
        width: 70px;
      }
      &-image{
        max-width: 251px;
        @media (max-width: 741px) {
          width: 45%;
        }
      }
    }
  }
</style>
